//=====================================================
//　エラーメッセージ（インライン）
//-----------------------------------------------------
//　引数のnameは入力項目のnameと一致するようにしてください。
//=====================================================

import { useFormContext } from "react-hook-form";

interface IFProps {
    name: string
}

export function ValidErrMsgInline(props:IFProps){

    const cf = useFormContext();

    if (!cf.formState.errors[props.name]){
        return null;
    } else {
        return (
            <div className="input-client_error-text">
                {cf.formState.errors[props.name].message}
            </div>
        )
    }

}